import { render, staticRenderFns } from "./statisCommissionList.vue?vue&type=template&id=e2f24f1a&scoped=true&"
import script from "./statisCommissionList.vue?vue&type=script&lang=ts&"
export * from "./statisCommissionList.vue?vue&type=script&lang=ts&"
import style0 from "./statisCommissionList.vue?vue&type=style&index=0&id=e2f24f1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f24f1a",
  null
  
)

export default component.exports